import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import type { Comment } from '@/types/blog';

export function useComments(postId: string) {
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchComments();
  }, [postId]);

  async function fetchComments() {
    try {
      setLoading(true);
      setError(null);

      // In demo mode, return mock comments
      const mockComments: Comment[] = [
        {
          id: '1',
          content: 'This is a great article! Thanks for sharing.',
          created_at: new Date().toISOString(),
          user: { email: 'john@example.com' }
        },
        {
          id: '2',
          content: 'Very insightful perspective on personal finance.',
          created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
          user: { email: 'sarah@example.com' }
        }
      ];

      setComments(mockComments);
    } catch (err) {
      console.error('Error fetching comments:', err);
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }

  const addComment = async (content: string) => {
    try {
      const newComment: Comment = {
        id: crypto.randomUUID(),
        content,
        created_at: new Date().toISOString(),
        user: { email: 'demo@example.com' }
      };

      setComments(prev => [newComment, ...prev]);
      return newComment;
    } catch (err) {
      console.error('Error adding comment:', err);
      throw err;
    }
  };

  return {
    comments,
    loading,
    error,
    addComment,
    refresh: fetchComments
  };
}